/**
 * Базовый URL API для Lower-клиента.
 *
 * Режимы:
 * - NEXT_PUBLIC_API_URL задан → прямой вызов (нужен CORS на бэке).
 * - LOWER_API_PROXY_TARGET + пустой NEXT_PUBLIC_API_URL → браузер бьёт в same-origin /api/*,
 *   Next rewrites проксируют на prod (без CORS).
 */
export function resolveApiBase(): string {
  const configured = process.env.NEXT_PUBLIC_API_URL?.trim();
  if (configured) {
    return configured.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined') {
    return '';
  }

  const proxyTarget = process.env.LOWER_API_PROXY_TARGET?.trim();
  if (proxyTarget) {
    return proxyTarget.replace(/\/$/, '');
  }

  return 'http://localhost:8000';
}

/**
 * Long-running calls (SSE agent, practice rebuild) must not go through Next rewrites:
 * the proxy aborts ~30s and the browser often shows HTTP 500.
 * Prefer direct API URL when configured (same as agent SSE).
 */
export function resolveLongRunningApiBase(): string {
  const direct = process.env.NEXT_PUBLIC_API_URL?.trim();
  if (direct) {
    return direct.replace(/\/$/, '');
  }
  const bypass = process.env.NEXT_PUBLIC_LOWER_SSE_API_URL?.trim();
  if (bypass) {
    return bypass.replace(/\/$/, '');
  }
  return resolveApiBase();
}
